// LANDING
var landingColours = [
  {
    "id": "188",
    "red": 194,
    "green": 80,
    "blue": 100,
    "hexValue": "#c25064",
    "colourName": "Pink Groove",
    "type": "dark"
  },
  {
    "id": "228",
    "red": 122,
    "green": 91,
    "blue": 143,
    "hexValue": "#7a5b8f",
    "colourName": "Purple Shock",
    "type": "dark"
  },
  {
    "id": "344",
    "red": 0,
    "green": 119,
    "blue": 138,
    "hexValue": "#00778a",
    "colourName": "Grand Turquoise",
    "type": "dark",
  },
  {
    "id": "187",
    "red": 188,
    "green": 47,
    "blue": 49,
    "hexValue": "#bc2f31",
    "colourName": "Red Alert",
    "type": "dark",
  }
]

export const landing = {
  title: "Hello,<br/> I am your colour wall assistant.",
  colours: landingColours[Math.floor(Math.random() * Math.floor(landingColours.length))]
};

export const randomTitlesResults = [
  "I like it a lot!",
  "Delightful choice of",
  "Outstanding",
  "It can't go wrong with",
  "Wow! I was going to paint my place",
  "You're so on trend with",
  "Awesome! I'd love to paint my place",
  "It's going to look great coloured",
]

//QUESTIONS
export const question1 = {
  title: "Are you painting an interior or exterior surface?",
  number: "one",
  color: {
    "id": "254",
    "red": 28,
    "green": 57,
    "blue": 105,
    "hexValue": "#1c3969",
    "colourName": "Sea Shepherd",
    "type": "dark",
  },
  colours: [
    {
      red: "",
      green: "",
      blue: "",
      name: "interior",
      image: "home-icon-int-white.svg",
    },
    {
      red: "",
      green: "",
      blue: "",
      name: "exterior",
      image: "home-icon-ext-white.svg",
    },
  ],
};

export const question2 = {
  title: "What are you looking for?",
  number: "two",
  color: {
    "id": '',
    "red": 255,
    "green": 255,
    "blue": 255,
    "colourName": "",
    "type": "cool"
  },
  colours: [
    {
      name: "Whites",
      mainTitle: "Clean & Fresh!",
      "colourName": "Snow Peak",
      "red": 229,
      "green": 228,
      "blue": 221,
      "id": "W12",
      type: "cool",
      category: "Whites",
    },
    {
      name: "Neutrals",
      mainTitle: "Neutrals, Classic",
      "id": "33",
      "colourName": "Lovey",
      "friendlyURL": "lovey",
      "red": 236,
      "blue": 209,
      "green": 222,
      type: "light",
      category: "Neutrals",
    },
    {
      name: "Colours",
      mainTitle: "A Splash of colour!",
      "id": "228",
      "red": 122,
      "green": 91,
      "blue": 143,
      "colourName": "Purple Shock",
      "type": "light",
    },
    {
      name: "Greys",
      mainTitle: "Smooth and moody Greys",
      "id": "433",
      "colourName": "Systematic",
      "red": 106,
      "blue": 119,
      "green": 112,
      type: "cool",
      category: "Greys",
    },
  ],
};

export const question3Colour = {
  title: "Pick your favourite colour",
  number: "three",
  color: {
    colourName: "",
    code: "",
    red: "255",
    green: "255",
    blue: "255",
    type: "light",
  },
  colours: [
    {
      mainTitle: "Cheerful Yellows, strong choice!",
      "id": "52",
      "colourName": "Buttercup Field",
      "friendlyURL": "buttercup-field",
      "red": 250,
      "blue": 100,
      "green": 211,
      type: "light",
      category: "Yellows",
    },
    {
      mainTitle: "Cheerful Oranges, for the win!",
      "id": "124",
      "colourName": "Fizzy Sherbet",
      "friendlyURL": "fizzy-sherbet",
      "red": 255,
      "blue": 162,
      "green": 207,
      type: "light",
      category: "Oranges",
    },
    {
      mainTitle: "Striking Reds. Nice vibes",
      "id": "185",
      "colourName": "Hot Pop Red",
      "friendlyURL": "hot-pop-red",
      "red": 197,
      "blue": 64,
      "green": 58,
      type: "light",
      category: "Reds",
    },
    {
      mainTitle: "Calming Blues ahead",
      "id": "279",
      "colourName": "Harbour View",
      "friendlyURL": "harbour-view",
      "red": 5,
      "blue": 189,
      "green": 120,
      type: "light",
      category: "Blues",
    },
    {
      mainTitle: "Soft and playful Purples",
      "id": "223",
      "colourName": "Lilac Mood",
      "red": 209,
      "blue": 220,
      "green": 191,
      type: "light",
      category: "Purples",
    },
    {
      mainTitle: "Delicate Pinks. Nice touch",
      "id": "176",
      "colourName": "Cherry Vanilla",
      "red": 254,
      "blue": 212,
      "green": 211,
      type: "light",
      category: "Pinks",
    },
    {
      mainTitle: "Soothing Greens ahoy!",
      "id": "363",
      "colourName": "Outside",
      "friendlyURL": "outside",
      "red": 181,
      "blue": 91,
      "green": 185,
      type: "light",
      category: "Greens",
    },
    {
      mainTitle: "Energising Teals all the way",
      "id": "342",
      "colourName": "Tempted Teal",
      "red": 33,
      "blue": 157,
      "green": 142,
      type: "light",
      category: "Teals",
    },
  ],
};

export const sheenData = {
  "matt": {
    "id": "matt",
    "name": "Matt",
    "copy": "Low light reflection for a soft, subtle finish.<br>Popular for darker colours.",
  },
  "low-sheen": {
    "id": "low-sheen",
    "name": "Low Sheen",
    "copy": "Popular and a good choice if you're unsure.<br>Low level of shine.",
  },
  "semi-gloss": {
    "id": "semi-gloss",
    "name": "Semi Gloss",
    "copy": "Medium gloss level that<br>withstands frequent cleaning.<br>Perfect for trims.",
  },
  "gloss": {
    "id": "gloss",
    "name": "Gloss",
    "copy": "High light reflection to accentuate surfaces like trims, windows and doors.",
  }
};

export const bunningsUrls = {
  "interior": {
    "white": {
      "matt": "https://www.bunnings.com.au/british-paints-white-matt-clean-and-protect-interior-paint-4l_p0561948",
      "low-sheen": "https://www.bunnings.com.au/british-paints-clean-and-protect-white-low-sheen-4l_p0561928",
      "semi-gloss": "https://www.bunnings.com.au/british-paints-4l-white-semi-gloss-clean-and-protect-interior-paint_p0561960",
      "gloss": "https://www.bunnings.com.au/british-paints-white-gloss-clean-and-protect-interior-paint-4l_p0561975",
    },
    "red": {
      "matt": "",
      "low-sheen": "",
      "semi-gloss": "",
      "gloss": ""
    },
    "mid": {
      "matt": "",
      "low-sheen": "https://www.bunnings.com.au/british-paints-mid-low-sheen-clean-and-protect-interior-paint-4l_p0561925",
      "semi-gloss": "",
      "gloss": ""
    },
    "extra-deep": {
      "matt": "",
      "low-sheen": "https://www.bunnings.com.au/british-paints-extra-deep-low-sheen-clean-and-protect-interior-paint-2l_p0561935",
      "semi-gloss": "",
      "gloss": ""
    },
    "extra-bright": {
      "matt": "",
      "low-sheen": "https://www.bunnings.com.au/british-paints-extra-bright-low-sheen-clean-and-protect-interior-paint-4l_p0561932",
      "semi-gloss": "",
      "gloss": ""
    }
  },
  "exterior": {
    "white": {
      "matt": "https://www.bunnings.com.au/british-paints-4-seasons-white-matt-exterior-paint-4l_p0207115?store=6403",
      "low-sheen": "https://www.bunnings.com.au/british-paints-4-seasons-low-sheen-white-exterior-paint-4l_p0207081",
      "semi-gloss": "https://www.bunnings.com.au/british-paints-4-seasons-semi-gloss-white-exterior-paint-4l_p0207121",
      "gloss": "https://www.bunnings.com.au/british-paints-4-seasons-gloss-white-exterior-paint-4l_p0207135",
    },
    "red": {
      "matt": "",
      "low-sheen": "https://www.bunnings.com.au/british-paints-4l-4-seasons-red-low-sheen-exterior-paint_p0207103",
      "gloss": "https://www.bunnings.com.au/british-paints-4-seasons-4l-gloss-red-exterior-paint_p0207149",
    },
    "mid": {
      "matt": "",
      "low-sheen": "https://www.bunnings.com.au/british-paints-4-seasons-mid-base-low-sheen-exterior-paint-4l_p0207087",
      "semi-gloss": "https://www.bunnings.com.au/british-paints-4-seasons-semi-gloss-mid-base-exterior-paint-4l_p0207125",
      "gloss": "https://www.bunnings.com.au/british-paints-4-seasons-gloss-mid-base-exterior-paint-4l_p0207140",
    },
    "extra-deep": {
      "matt": "",
      "low-sheen": "https://www.bunnings.com.au/british-paints-4-seasons-low-sheen-extra-deep-exterior-paint-4l_p0207095",
      "semi-gloss": "https://www.bunnings.com.au/british-paints-4-seasons-semi-gloss-extra-deep-exterior-paint-4l_p0207127",
      "gloss  ": "https://www.bunnings.com.au/british-paints-4-seasons-extra-deep-gloss-exterior-paint-4l_p0207144",
    },
    "extra-bright": {
      "matt": "",
      "low-sheen": "https://www.bunnings.com.au/british-paints-4-seasons-extra-bright-low-sheen-exterior-paint-4l_p0207100",
      "semi-gloss": "https://www.bunnings.com.au/british-paints-4-seasons-semi-gloss-extra-bright-exterior-paint-4l_p0207129",
      "gloss": "https://www.bunnings.com.au/british-paints-4-seasons-gloss-extra-bright-exterior-paint-4l_p0207148",
    }

  }
}






